const hub = {
  // Quick Stats
  quickStats: "סטטיסטיקות מהירות",
  totalEntities: "סך ישויות",
  docsThisWeek: "מסמכים השבוע",
  openTasks: "משימות פתוחות",
  aiConversations: "שיחות AI היום",
  // Activity
  recentActivity: "פעילות אחרונה",
  noActivity: "אין פעילות אחרונה",
  // BI Charts
  biCharts: "גרפים",
  statusDistribution: "פילוח סטטוסים",
  activityTimeline: "ציר זמן פעילות",
  entityBreakdown: "פילוח ישויות",
  last7Days: "7 ימים אחרונים",
  last30Days: "30 ימים אחרונים",
  // Quick Access
  quickAccess: "גישה מהירה",
  // Context Menu
  openItem: "פתח",
  openInSidePanel: "פתח בפאנל צדדי",
  duplicate: "שכפל",
  deleteItem: "מחק",
  addToFavorites: "הוסף למועדפים",
  removeFromFavorites: "הסר מהמועדפים",
  copyLink: "העתק קישור",
  editIcon: "ערוך אייקון",
  colorRule: "כלל צבע",
  colorRuleTitle: "כלל צבע",
  colorRuleField: "שדה",
  colorRuleValue: "ערך",
  colorRuleColor: "צבע",
  colorRuleSave: "שמור",
  colorRuleRemove: "הסר כלל",
  linkCopied: "קישור הועתק",
} as const;
export default hub;
